var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgStartDate = function SvgStartDate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.95 15.23 1.988 1.693v3.969a1.108 1.108 0 0 0 2.216 0v-5.239l-2.216-1.692.596-3.153c1.07 1.052 2.62 1.813 4.362 2.043.36.048 1.104-.02 1.104-.759s-.801-.9-1.176-.974c-1.362-.268-2.474-.989-3.097-1.918l-.994-1.354c-.398-.508-.994-.846-1.69-.846-.148 0-.273.021-.397.042s-.248.043-.398.043L9.082 8.946v2.984a.994.994 0 1 0 1.987 0v-1.884l1.79-.592-1.627 7.348-3.844-.541a.989.989 0 1 0-.23 1.963l5.612.527 1.181-3.52zm4.214-11.087c0-1.179-.78-2.143-2.049-2.143s-1.956.964-1.956 2.143c0 1.178.687 2.143 1.956 2.143 1.27 0 2.05-.965 2.05-2.143zM3.538 11.286c0-.395.32-.714.715-.714H5.9A.714.714 0 0 1 5.9 12H4.253a.714.714 0 0 1-.715-.714zm-.824-3.572a.714.714 0 1 0 0 1.429H6.67a.714.714 0 0 0 0-1.429H2.714z"
  })));
};

export default SvgStartDate;